import { atom, type WritableAtom } from 'nanostores';

import type { SyncSettings } from './client/sync_client.js';
import { addSyncCapabilities, type SyncAtom } from './sync_store.js';

export type { SyncAtom };

export function syncAtom<
  Value extends
    | string
    | number
    | boolean
    | undefined
    | Record<string, unknown>
    | unknown[],
>(
  name: string,
  initial: Value,
  syncSettings: SyncSettings<WritableAtom<Value>>,
): SyncAtom<Value> {
  const store = atom<Value>(initial);
  return addSyncCapabilities(store, name, syncSettings);
}
